import actions from '../../actionTypes';

export default siteId => {
  return {
    type: actions.DELETE_SITE,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/deleteSite.js